import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { SubjectLocation } from "../../../_objects/subject-model";

@Injectable({
  providedIn: "root"
})
export class LocationStateService {
  private filterLocationSubject$ = new BehaviorSubject<SubjectLocation | null>(null);
  public filterLocation$: Observable<SubjectLocation | null> = this.filterLocationSubject$.asObservable();

  private filterTermLocationsSubject$ = new BehaviorSubject<SubjectLocation[]>([]);
  public filterTermLocations$: Observable<SubjectLocation[]> = this.filterTermLocationsSubject$.asObservable();

  private isDataPlateSelectedSubject$ = new BehaviorSubject<boolean>(false);
  public isDataPlateSelected$: Observable<boolean> = this.isDataPlateSelectedSubject$.asObservable();

  public getFilterLocation(): Observable<SubjectLocation | null> {
    return this.filterLocation$;
  }

  public setFilterLocation(location: SubjectLocation): void {
    this.filterLocationSubject$.next(location);
  }
  public getFilterTermLocations(): Observable<SubjectLocation[]> {
    return this.filterTermLocations$;
  }

  public setFilterTermLocations(locations: SubjectLocation[]): void {
    this.filterTermLocationsSubject$.next(locations);
  }

  public getIsDataPlateSelected(): Observable<boolean> {
    return this.isDataPlateSelected$;
  }

  public setIsDataPlateSelected(isSelected: boolean): void {
    this.isDataPlateSelectedSubject$.next(isSelected);
  }
}
